import { useEffect, useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { DATA_CHANGE_CHANNEL, DATA_CHANGE_EVENT } from "@/lib/apiClient";

export function DataChangeListener() {
  const queryClient = useQueryClient();
  const pendingRef = useRef(false);

  useEffect(() => {
    const doRefresh = async () => {
      if (pendingRef.current) return;
      pendingRef.current = true;

      try {
        // Invalidar y refrescar inmediatamente todas las queries activas
        await queryClient.invalidateQueries();
        await queryClient.refetchQueries({ type: 'active', stale: true });
      } finally {
        // Pequeño delay antes de permitir otro refresh para evitar spam
        setTimeout(() => {
          pendingRef.current = false;
        }, 50);
      }
    };

    const handleChange = () => {
      // Ejecutar inmediatamente sin delay
      doRefresh();
    };

    window.addEventListener(DATA_CHANGE_EVENT, handleChange);

    let channel: BroadcastChannel | null = null;
    if (typeof BroadcastChannel !== "undefined") {
      channel = new BroadcastChannel(DATA_CHANGE_CHANNEL);
      channel.onmessage = handleChange;
    }

    return () => {
      window.removeEventListener(DATA_CHANGE_EVENT, handleChange);
      if (channel) {
        channel.close();
      }
    };
  }, [queryClient]);

  return null;
}
